import { render, staticRenderFns } from "./productContentBanner.vue?vue&type=template&id=154ea947&scoped=true"
import script from "./productContentBanner.vue?vue&type=script&lang=js"
export * from "./productContentBanner.vue?vue&type=script&lang=js"
import style0 from "./productContentBanner.vue?vue&type=style&index=0&id=154ea947&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154ea947",
  null
  
)

export default component.exports